import React from 'react';
import { motion } from 'framer-motion';
import { PawPrint, Clock, User, Mountain, Sparkles, Tag } from 'lucide-react';
const tiers = [{
  title: 'Kratek sprehod',
  subtitle: 'do 30 min',
  price: '10 €',
  description: 'Sproščen in aktiven sprehod, prilagojen tempu in energiji psa.',
  icon: Clock,
  bg: 'bg-brand-pink-light',
  iconBg: 'bg-brand-pink',
  iconColor: 'text-white'
}, {
  title: 'Individualni sprehod',
  subtitle: 'dodatek za samo 1 psa',
  price: '+5 €',
  description: 'Za kužke, ki imajo raje mir, več pozornosti ali težje hodijo v skupini.',
  icon: User,
  bg: 'bg-brand-brown-light',
  iconBg: 'bg-brand-brown',
  iconColor: 'text-white'
}, {
  title: 'Dolg sprehod',
  subtitle: 'do 90 min',
  price: '+10 €',
  description: 'Za bolj aktivne pse, ki potrebujejo več gibanja, raziskovanja in igre.',
  icon: Mountain,
  bg: 'bg-brand-green-light',
  iconBg: 'bg-brand-green',
  iconColor: 'text-white'
}, {
  title: 'Sprehod z razvajanjem',
  subtitle: 'igrivo učenje, kratko česanje, dodatna igra, slikice',
  price: '+5 €',
  description: 'Malo dodatne pozornosti in zabave za vašega kužka 🐶',
  icon: Sparkles,
  bg: 'bg-brand-pink-light',
  iconBg: 'bg-brand-pink',
  iconColor: 'text-white'
}];
export function Pricing() {
  return;
}